import Bold from './check-circle.bold.svg?react'
import Duotone from './check-circle.duotone.svg?react'
import Fill from './check-circle.fill.svg?react'
import Regular from './check-circle.regular.svg?react'
import { createIcon } from './factory'

export const CheckCircle = createIcon({
  regular: Regular,
  bold: Bold,
  fill: Fill,
  duotone: Duotone,
})
